import m from "../../../../geodata/es2015/region/usa/ncHigh";
window.am4geodata_region_usa_ncHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/ncHigh.js
// module id = null
// module chunks = 